var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_126)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7465 4.83407C23.1189 5.20883 23.3863 5.67482 23.522 6.18541C24.0238 8.06995 24.0238 12 24.0238 12C24.0238 12 24.0238 15.93 23.522 17.8145C23.3863 18.3251 23.1189 18.7911 22.7465 19.1658C22.3741 19.5406 21.9099 19.811 21.4002 19.95C19.5238 20.4545 12.0238 20.4545 12.0238 20.4545C12.0238 20.4545 4.5238 20.4545 2.64744 19.95C2.13773 19.811 1.67346 19.5406 1.30109 19.1658C0.92872 18.7911 0.661309 18.3251 0.525622 17.8145C0.0238038 15.93 0.0238037 12 0.0238037 12C0.0238037 12 0.0238038 8.06995 0.525622 6.18541C0.661309 5.67482 0.92872 5.20883 1.30109 4.83407C1.67346 4.4593 2.13773 4.18891 2.64744 4.04996C4.5238 3.54541 12.0238 3.54541 12.0238 3.54541C12.0238 3.54541 19.5238 3.54541 21.4002 4.04996C21.9099 4.18891 22.3741 4.4593 22.7465 4.83407ZM15.842 12L9.56927 8.43135V15.5686L15.842 12Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.c541c8612744cb48fd42c0fb7e9825c0.svg";
export { ForwardRef as ReactComponent };